import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { IntlProvider } from 'react-intl-redux';
import { LocaleProvider } from 'antd';
import jaJP from 'antd/lib/locale-provider/ja_JP';
import App from './App';
import ScrollToTop from './components/ScrollToTop';

/**
 * Root Component
 * * It takes care of locale redirects based on routes from App
 */
const Root = ({ store }) => {
  const { locale, messages } = store.getState().intl;
  return (
    <Provider store={store}>
      <LocaleProvider locale={jaJP}>
        <IntlProvider locale={locale} messages={messages}>
          <BrowserRouter>
            <ScrollToTop>
              <Switch>
                <Redirect from="/salon" to="/en/news-and-events/beauty-innovator-award-2018" />
                <Route path="/ja_jp/salon-locator" component={() => {
                  const url = 'https://www.shiseido-professional.com/ja/salon-locator';
                  const key = new URLSearchParams(window.location.search).get('key');

                  if (key) {
                    window.location.href = url + '?key=' + key;
                  } else {
                    window.location.href = url;
                  }

                  return null;
                }} />
                <Route path="/:locale" component={App} />
                <Redirect to="/en" />
              </Switch>
            </ScrollToTop>
          </BrowserRouter>
        </IntlProvider>
      </LocaleProvider>
    </Provider>
  );
};

Root.propTypes = {
  store: PropTypes.object.isRequired, // eslint-disable-line
};

export default Root;



// WEBPACK FOOTER //
// ./src/Root.js